import ProjectExpertisePriority from './ProjectExpertisePriority';
export default ProjectExpertisePriority;